module.exports = __webpack_public_path__ + "static/media/img93.697b5cde.jpg";